var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29289 9.29289L9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071L11 8.41421L11 20C11 20.5523 10.5523 21 10 21C9.44771 21 9 20.5523 9 20L9 8.41421L6.7071 10.7071C6.31658 11.0976 5.68342 11.0976 5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.5C18 6.05229 18.4477 6.5 19 6.5C19.5523 6.5 20 6.05229 20 5.5V4C20 1.79086 18.2091 0 16 0L4 0C1.79086 0 -1.90735e-06 1.79086 -1.90735e-06 4V5.5C-1.90735e-06 6.05229 0.447714 6.5 0.999998 6.5C1.55228 6.5 2 6.05229 2 5.5V4C2 2.89543 2.89543 2 4 2L16 2C17.1046 2 18 2.89543 18 4V5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.a107b3981d845eb0f185c1fdeb134063.svg";
export { ForwardRef as ReactComponent };